import { QueryClient, type DefaultOptions, type Query } from "@tanstack/react-query";
import { ApiJsonClientError } from "./api-json-client";

function shouldRetryQuery(failureCount: number, error: unknown) {
  if (error instanceof DOMException && error.name === "AbortError") return false;
  if (failureCount >= 1) {
    return false;
  }

  if (error instanceof ApiJsonClientError) {
    if (error.status === 401 || error.status === 403 || error.status === 404) {
      return false;
    }

    return error.status >= 500;
  }

  return true;
}

function shouldRefetchOnMount(query: Query) {
  if (query.state.data === undefined) {
    return "always" as const;
  }

  return query.state.isInvalidated;
}

export const portalQueryDefaults: DefaultOptions = {
  queries: {
    staleTime: 30_000,
    gcTime: 15 * 60_000,
    retry: shouldRetryQuery,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    refetchOnMount: shouldRefetchOnMount,
  },
  mutations: {
    retry: false,
  },
};

export function createPortalQueryClient() {
  return new QueryClient({
    defaultOptions: portalQueryDefaults,
  });
}
